var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-upload" },
    [
      _c(
        "el-input",
        {
          attrs: {
            placeholder: _vm.placeholder,
            value: _vm.fileName,
            readonly: "readonly",
            disabled: _vm.disabled,
          },
        },
        [
          _c(
            "template",
            { slot: "append" },
            [
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    "on-success": _vm.onSuccess,
                    "on-error": _vm.onError,
                    action: _vm.domain + "/upload",
                    headers: _vm.headers,
                    "show-file-list": false,
                    "list-type": "text",
                    "before-upload": _vm.beforeUpload,
                    loading: _vm.loading,
                    "on-change": _vm.fileChange,
                    "file-list": _vm.fileList,
                    accept: _vm.accept,
                    disabled: _vm.disabled,
                    "with-credentials": "",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { color: "#1FA0E8" },
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.upload.uploadField")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm.showFileTemplate
        ? _c(
            "span",
            { staticClass: "file-template", on: { click: _vm.downLoad } },
            [
              _c("i", { staticClass: "el-icon-download" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("components.upload.download")) +
                  _vm._s(_vm.templateInfoFileName) +
                  " "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }